<template>
  <OverviewTab
    :market="market"
    :initial-fields="initialFields"
    :services="services"
    :title="titlePackage"
    :intro="intro"
  />
</template>

<script setup lang="ts">
import OverviewTab from '~/components/sustainability/OverviewTab.vue'
import type { TMarketServiceConfig } from '~/src/types/markets'

/*-------------------------------------
  Constants
-------------------------------------*/
const intro = {
  title:
    'Benchmark’s Nickel ESG Report is an annual subscription with quarterly updates.',
  body: [
    'Benchmark’s Nickel ESG Report is an annual subscription with quarterly updates.',
    'The report offers comprehensive coverage of the evolving ESG landscape in the upstream nickel supply chain, forecasted trends, Nickel carbon intensity curves and our Benchmark Global LCAs, which measure the environmental impact of mining nickel ore and producing both refined nickel and nickel sulphate.',
    'To keep subscribers up to date, the report contains individual assessments of all mined nickel, refined nickel and nickel sulphate producers, with indicators measuring ESG performance alongside tiers allocated based on our Benchmark’s Sustainability Index Methodology. Utilising data collected through Benchmark’s independent research and analysis, this report provides detailed and expert ESG assessment and monitoring of the nickel industry.',
  ],
  images: {
    one: {
      url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1719416656/assets/market/nickel/nickel-1_ge67qk.jpg',
      alt: 'Nickel Forecasts',
    },
    two: {
      url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1719416655/assets/market/nickel/nickel-2_nklewv.jpg',
      alt: 'Nickel Forecasts',
    },
    three: {
      url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1719416657/assets/market/nickel/nickel-3_rnhrr5.jpg',
      alt: 'Nickel Forecasts',
    },
  },
}

const services = [
  {
    icon: 'services/icon-success-chart',
    description: 'Company-by-company ESG database',
  },
  {
    icon: 'services/icon-presentation',
    description: 'Materiality assessment and critical ESG analysis',
  },
  {
    icon: 'services/icon-eco-earth',
    description: 'Benchmark Global Nickel LCA',
  },
  {
    icon: 'services/icon-consultancy',
    description: 'ESG news brief and global policy review',
  },
  {
    icon: 'services/icon-idea',
    description: 'Access to Benchmark’s analysts',
  },
]

/*-------------------------------------
  Meta
-------------------------------------*/
definePageMeta({
  isTab: true,
  scrollToTop: false,
  middleware: 'redirect-tab',
})

/*-------------------------------------
  Props & Refs
-------------------------------------*/
const props = defineProps<{
  market: TMarketServiceConfig
  initialFields: string[]
}>()

const titlePackage = ref(`${props.market.name} ESG Report`)
</script>
